import DateFnsUtils from '@date-io/date-fns';
import React, { useEffect, useState } from 'react';
import trLocale from 'date-fns/locale/tr';
import SearchIcon from '@material-ui/icons/Search';
import { sc, moneyFormat } from 'src/utils/Common';
import {
  Card,
  Breadcrumbs,
  Link,
  Typography,
  CardContent,
  Container,
  Divider,
  Grid,
  TextField,
  ThemeProvider,
  MenuItem,
  Backdrop,
  CircularProgress,
  Button,
  Snackbar,
} from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core/styles';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import axios from 'src/utils/axios';

import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';
import ExcelExport from 'src/components/ExcelExport';
import { useHistory } from 'react-router-dom';
import { maskStringData } from 'src/MaskData';

const useStyles = makeStyles(theme => ({
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0)'
    },
    root: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    cardscontent: {
      minHeight: 300
    },
    backdrop: {
      zIndex: 1500,
      color: '#fff'
    },
    tableRow: {
      '&$hover:hover': {
        backgroundColor: '#DEF5E5'
      }
    },
    tableCell: {
      '$hover:hover &': {
        color: 'black'
      }
    },
    hover: {},
    searchB: {
      flexGrow: 1,
      height: 42,
      padding: theme.spacing(0, 2),
      display: 'flex',
      alignItems: 'center'
    },
    searchIconB: {
      marginRight: theme.spacing(0),
      color: theme.palette.icon
    },
    searchInputB: {
      flexGrow: 1
    },
    searchButtonB: {
      backgroundColor: theme.palette.common.white,
      marginLeft: theme.spacing(2)
    },
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    }
  }));
  

function Query(){
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const SessionUser = getUser();
  const [statusList] = useState([
    { Id: 1, Name: t('lblNew') },
    { Id: 2, Name: t('lblCancel') },
    { Id: 3, Name: t('lblSAPSent') },
    { Id: 4, Name: t('lblFailed') }
  ]);
  const [selectedStatus, setSelectedStatus] = useState({ Id: 1, Name: 'New' });
  const [StartDateSearch, setStartDateSearch] = useState(
    moment()
      .startOf('day')
      .add(-7, 'days')
      .add(12, 'hours')
      .format('YYYY-MM-DD')
  );
  const [EndDateSearch, setEndDateSearch] = useState(new Date());
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [ResponseType, setResponseType] = useState('success');

  const [loading, setLoading] = useState(false);
  const [QuerySearchScreenData, setQuerySearchScreenData] = useState([]);
  const [ResponseDsc, setResponseDsc] = useState('');
  const [statusDetailList] = useState([
    { Id: 0, Name: t('lblNone') },
    { Id: 1, Name: t('lblNew') },
    { Id: 2, Name: t('lblCancel') },
    { Id: 3, Name: t('lblSent') },
    { Id: 4, Name: t('lblQuatation') }
  ]);
  const [selectedStatusDetail, setSelectedStatusDetail] = useState({ Id: 0, Name: 'None' });

  const defaultMaterialOrder = {
    workOrderId: null,
    service: SessionUser.ServiceShopName,
    orderNumber: null,
    orderDate: moment().format('YYYY-MM-DD'),
    sapNumber: '',
    jobNumber: '',
    poNumber: '',
    modelCode: '',
    status: statusList[0].Name,
    recipientName: '',
    description: '',
    statusDetail: statusDetailList[0].Name,
    recipientAddress: '',
    ServiceShopId:
      SessionUser.UserType === 1 || SessionUser.UserType === 2
        ? SessionUser.ServiceShopId
        : 0
  };


  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const changeSelectedStatus = status => {
    setSelectedStatus(status);
  };

  const changeSelectedStatusDetail = statusDetail => {
    setSelectedStatusDetail(statusDetail);
  };

  const localeMap = {
    tr: trLocale
  };

  const locale = localStorage.getItem('i18nextLng');

  const siyah = '#424242';

  const materialTheme = createMuiTheme({
    palette: {
      primary: {
        contrastText: '#FFFFFF',
        dark: siyah,
        main: siyah,
        light: siyah
      }
    }
  });

  const [MaterialOrderData, setMaterialOrderData] = useState(
    defaultMaterialOrder
  );

  const handleChangeStartDateSearch = e => {
    setStartDateSearch(e);
  };
  const handleChangeEndDateSearch = e => {
    setEndDateSearch(e);
  };

  const exportData = (data) => {
    var json = []

    data.map(row => (
      row.MaterialOrderDetails ? row.MaterialOrderDetails.map(det => {
        var temp = {};
        temp.lblWorkOrderId = row.WorkOrderId;
        temp.lblServiceShop = `${row.SourceServiceShopCode} ${row.ServiceShop}`;
        temp.lblMaterialOrderId = row.MaterialOrderId;
        temp.lblRecipientDsc = row.RecipientDsc;
        temp.lblRecipientAddress = row.RecipientAddress;
        temp.lblRecipientId = row.RecipientId;
        temp.lblMaterialCode = det.MaterialCode;
        temp.lblMaterial = det.Material;
        temp.lblQuantity = det.Qty;
        temp.lblModelCode = det.ModelCode;
        temp.lblProductName = det.ProductName;
        temp.lblSapNr = row.SapNr;
        temp.lblOrderDate = row.OrderDate === undefined ? '' : SessionUser.TenantId == 79 ? moment(row.OrderDate).format('MM/DD/YYYY HH:mm') : moment(row.OrderDate).format('DD/MM/YYYY HH:mm');
        temp.lblMaterialOrderStatus = row.MaterialOrderStatus;
        temp.lblWorkOrderStatus = row.WorkOrderStatus;
        temp.lblDescription = row.Dsc;
        temp.lblTotalPrice = SessionUser.ServiceShopPriceVisible ? moneyFormat(
          det.PriceWithWat,
          SessionUser.TenantCode,
          SessionUser.CurrencyUnit
        ) : 0 + `${SessionUser.CurrencyUnit}`;
        json.push(temp)
      }
      ) : null))

    return json
  }

  const history = useHistory();

  function handleRoute(row){
    var value = QuerySearchScreenData.filter(x => x.MaterialOrderId == row.MaterialOrderId)

    if (history && history.push && typeof history.push === 'function') {
      if(value[0].ShipToToServiceShopId != 0){
          history.push({pathname:'/materialOrder/Create/ForPartner',state:value[0]});
      }else if(value[0].ShipToToConsumerId != 0){
        history.push({pathname:'/materialOrder/Create/ForConsumer',state:value[0]});
      }
    }else{
      console.error('history.push is not available. Application might crash.');
    }
  }
  
  const GetMaterialOrderRequest = () => {
    setQuerySearchScreenData([]);
    setLoading(true);
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const Request = {
      StatusId: selectedStatus.Id,
      StartDate,
      EndDate,
      ServiceShopId: SessionUser.ServiceShopId,
      OrderNr: MaterialOrderData.orderNumber ? MaterialOrderData.orderNumber : null,
      SapNr: MaterialOrderData.sapNumber,
      StatusDetailId: selectedStatusDetail.Id,
      workOrderId: MaterialOrderData.workOrderId ? MaterialOrderData.workOrderId : null
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialOrder', Request, RequestHeaders)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setQuerySearchScreenData(Response);
        } else {
          setQuerySearchScreenData([]);
          setResponseType('warning');
          setResponseDsc(t('lblNoFoundOrder'));
          setOpenSnackbar(true);
        }
        setLoading(false);
      })
      .catch(error => {
        setQuerySearchScreenData([]);
        setLoading(false);
        setResponseType('error');
        setResponseDsc(t('lblError'));
        setOpenSnackbar(true);
      });
  };

    return(
        <Page>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
        >
          <Alert
            onClose={handleSnackbarClose}
            message={ResponseDsc}
            variant={ResponseType}
          />
        </Snackbar>
            <Container maxWidth="xl" spacing={1}>
                <Breadcrumbs>
                    <Link color="inherit">Sirius</Link>
                    <Typography color="textPrimary">{t('Material_Order')}</Typography>
                    <Typography color="textPrimary">{t('lblQuery')}</Typography>
                </Breadcrumbs>
                <Divider />
                <Card >
                    <CardContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={2} lg={2}>
                        <TextField
                            disabled
                            size="small"
                            fullWidth
                            label={t('lblServiceShop')}
                            id="ServiceShop"
                            variant="outlined"
                            value={SessionUser.ServiceShopCode + '-' + SessionUser.ServiceShopName}
                        />
                        </Grid>
                        <Grid item xs={12} sm={1} lg={1}>
                        <TextField
                            size="small"
                            fullWidth
                            select
                            label={t('lblStatus')}
                            id="StatusId"
                            variant="outlined"
                            value={selectedStatus.Id}
                        >
                            {statusList?.map(h => {
                            return (
                                <MenuItem
                                onClick={() => changeSelectedStatus(h)}
                                key={h.Id}
                                value={h.Id}
                                >
                                {h.Name}
                                </MenuItem>
                            );
                            })}
                        </TextField>
                        </Grid>
                        <Grid item xs={12} sm={2} lg={2}>
                        <ThemeProvider theme={materialTheme}>
                            <MuiPickersUtilsProvider
                            utils={DateFnsUtils}
                            locale={localeMap[locale]}
                            >
                            <KeyboardDatePicker
                                color="primary"
                                inputVariant="outlined"
                                id="orderDate"
                                size="small"
                                invalidDateMessage={t('hatali_tarih')}
                                format="dd.MM.yyyy"
                                fullWidth
                                label={t('BaslangicTarihi')}
                                variant="outlined"
                                value={StartDateSearch}
                                onChange={e => handleChangeStartDateSearch(e)}
                                KeyboardButtonProps={{
                                'aria-label': 'change date'
                                }}
                            />
                            </MuiPickersUtilsProvider>
                        </ThemeProvider>
                        </Grid>
                        <Grid item xs={12} sm={2} lg={2}>
                        <ThemeProvider theme={materialTheme}>
                            <MuiPickersUtilsProvider
                            utils={DateFnsUtils}
                            locale={localeMap[locale]}
                            >
                            <KeyboardDatePicker
                                color="primary"
                                inputVariant="outlined"
                                id="orderDate"
                                size="small"
                                invalidDateMessage={t('hatali_tarih')}
                                format="dd.MM.yyyy"
                                fullWidth
                                autoComplete="off"
                                label={t('BitisTarihi')}
                                variant="outlined"
                                value={EndDateSearch}
                                onChange={e => handleChangeEndDateSearch(e)}
                                KeyboardButtonProps={{
                                'aria-label': 'change date'
                                }}
                            />
                            </MuiPickersUtilsProvider>
                        </ThemeProvider>
                        </Grid>
                        <Grid item xs={12} sm={1} lg={1}>
                          <TextField
                              size="small"
                              id="workOrderId"
                              autoComplete="no"
                              value={MaterialOrderData.workOrderId}
                              onChange={event =>
                              setMaterialOrderData({
                                  ...MaterialOrderData,
                                  workOrderId: event.target.value
                              })}
                              fullWidth
                              label={t('lblWorkOrderId')}
                              variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12} sm={1} lg={1}>
                        <TextField
                            size="small"
                            id="orderNumber"
                            autoComplete="no"
                            value={MaterialOrderData.orderNumber}
                            onChange={event =>
                            setMaterialOrderData({
                                ...MaterialOrderData,
                                orderNumber: event.target.value
                            })}
                            fullWidth
                            label={t('lblOrderNumber')}
                            variant="outlined"
                        />
                        </Grid>
                        <Grid item xs={12} sm={1} lg={1}>
                        <TextField
                            size="small"
                            id="SapNr"
                            autoComplete="no"
                            value={MaterialOrderData.sapNumber}
                            onChange={event =>
                            setMaterialOrderData({
                                ...MaterialOrderData,
                                sapNumber: event.target.value
                            })}
                            fullWidth
                            label={t('lblSapNr')}
                            variant="outlined"
                        />
                        </Grid>
                        <Grid item xs={12} sm={1} lg={1}>
                        <TextField
                            size="small"
                            fullWidth
                            select
                            label={t('lblMaterialStatus')}
                            id="StatusDetailId"
                            variant="outlined"
                            value={selectedStatusDetail.Id}
                        >
                            {statusDetailList?.map(h => {
                            return (
                                <MenuItem
                                onClick={() => changeSelectedStatusDetail(h)}
                                key={h.Id}
                                value={h.Id}
                                >
                                {h.Name}
                                </MenuItem>
                            );
                            })}
                        </TextField>
                        </Grid>
                        <Grid item xs={12} sm={2} lg={1}>
                        <Button
                            variant="contained"
                            style={{
                            backgroundColor: '#1E5128',
                            color: 'white'
                            }}
                            fullWidth
                            endIcon={<SearchIcon />}
                            onClick={GetMaterialOrderRequest}
                        >
                            {t('search')}
                        </Button>
                        </Grid>
                        <Grid item xs={12} sm={2} lg={1}>
                        <ExcelExport JsonData={exportData(QuerySearchScreenData)} />
                        </Grid>

                    </Grid>
                    </CardContent>
                    <CardContent>
                    <TableContainer className={classes.container}>
                        <Table 
                        stickyHeader 
                        aria-label="sticky table" 
                        className={classes.table}
                        size="small"
                        >
                        <TableHead>
                            <TableRow>
                            <TableCell align="left">{t('lblJobNumber')}</TableCell>
                            <TableCell align="left">{t('PO Number')}</TableCell>
                            <TableCell align="left">{t('lblServiceShop')}</TableCell>
                            <TableCell align="left">{t('lblShipTo')}</TableCell>
                            <TableCell align="left">{t('lblConsumerName')}</TableCell>
                            <TableCell align="left">{t('lblCreateType')}</TableCell>
                            <TableCell align="left">{t('lblOrderNumber')}</TableCell>
                            <TableCell align="left">{t('lblMaterialCode')}</TableCell>
                            <TableCell align="left">{t('lblMaterial')}</TableCell>
                            <TableCell align="left">{t('lblQuantity')}</TableCell>
                            <TableCell align="left">{t('lblOrderDate')}</TableCell>
                            <TableCell align="left">{t('lblSapNumber')}</TableCell>
                            <TableCell align="left">{t('lblStatus')}</TableCell>
                            <TableCell align="left">{t('lblWorkOrderStatus')}</TableCell>
                            <TableCell align="left">{t('lblDescription')}</TableCell>
                            <TableCell align="left">{t('lblTotal')}</TableCell>
                            <TableCell align="left">{t('lblWarrantyType')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                                {QuerySearchScreenData ? QuerySearchScreenData.map(row => (
                                row.MaterialOrderDetails ? row.MaterialOrderDetails.map(det => (
                                    <TableRow
                                    key={row.MaterialOrderId}
                                    hover
                                    classes={{ hover: classes.hover }}
                                    className={classes.tableRow}
                                    onClick={() => handleRoute(row)}
                                    >
                                    <TableCell align="left">
                                        {row.WorkOrderId}
                                    </TableCell>
                                    <TableCell align="left">
                                        {row.poNumber}
                                    </TableCell>
                                    <TableCell align="left">
                                        {`${row.SourceServiceShopCode} ${row.ServiceShopDsc}`}
                                    </TableCell>
                                    <TableCell align="left">
                                        {row.ShipTo}
                                    </TableCell>
                                    <TableCell align="left">
                                        {row.ConsumerFullName !== " " ? maskStringData(row.ConsumerFullName): ''}
                                    </TableCell>
                                    <TableCell align="left">
                                        {`${row.ShipToToConsumerId != 0 ? t('ForConsumer') : row.ShipToToOtc != 0 ? t('ForOTC') : row.ShipToToServiceShopId != 0 ? t('ForPartner') : row.ShipToToRetailerId != 0 ? t('ForPartnerRetailer') : ''}`}
                                    </TableCell>
                                    <TableCell align="left">
                                        {row.MaterialOrderId}
                                    </TableCell>
                                    <TableCell align="left">
                                        {det.MaterialCode}
                                    </TableCell>
                                    <TableCell align="left">
                                        {det.Material}
                                    </TableCell>
                                    <TableCell align="left">
                                        {det.Qty}
                                    </TableCell>
                                    <TableCell align="left">{row.OrderDate === undefined ? '' : SessionUser.TenantId == 79 ? moment(row.OrderDate).format('MM/DD/YYYY HH:mm') : moment(row.OrderDate).format('DD/MM/YYYY HH:mm')}</TableCell>
                                    <TableCell align="left">
                                        {row.SapNr}
                                    </TableCell>
                                    <TableCell align="left">
                                        {det.MaterialOrderDetailStatus}
                                    </TableCell>
                                    <TableCell align="left">
                                        {row.WorkOrderStatus}
                                    </TableCell>
                                    <TableCell align="left">{row.Dsc}</TableCell>
                                    <TableCell align="left">
                                        {SessionUser.ServiceShopPriceVisible ?  moneyFormat(
                                        det.PriceWithWat*det.Qty,
                                        SessionUser.TenantCode,
                                        SessionUser.CurrencyUnit
                                        ) : 0}
                                        {`${SessionUser.CurrencyUnit}`}
                                    </TableCell>
                                    <TableCell align="left">{row.WarrantyType}</TableCell>
                                    </TableRow>
                                )) : null
                                ))
                                : null}
                        </TableBody>
                        </Table>
                    </TableContainer>
                    </CardContent>
                </Card>
            </Container>        
        </Page>
    )
}

export default Query;


